module.exports = __webpack_public_path__ + "static/ux-7d8ede5f92ece9dc62d76aa7e3094f48.svg";